import { render, staticRenderFns } from "./guanqiaLostData.vue?vue&type=template&id=77c3583c&"
import script from "./guanqiaLostData.vue?vue&type=script&lang=js&"
export * from "./guanqiaLostData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77c3583c')) {
      api.createRecord('77c3583c', component.options)
    } else {
      api.reload('77c3583c', component.options)
    }
    module.hot.accept("./guanqiaLostData.vue?vue&type=template&id=77c3583c&", function () {
      api.rerender('77c3583c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/guanqia/guanqiaLostData.vue"
export default component.exports